import Dialog from "../1. Core/Controls/Dialog/Dialog";
import {HighlightRow, IBattle} from "../10. Battle/types";
import Label from "../1. Core/Controls/Label/Label";
import Select from "../1. Core/Controls/Select/Select";
import TextField from "../1. Core/Controls/TextField/TextField";
import TimeEdit, {TimeEditMode} from "../1. Core/Controls/TimeEdit/TimeEdit";
import Font from "../1. Core/Font";
import NP from "../1. Core/NP";
import CreateBoutDialog from "../10. Battle/Library/Dialogs/CreateBoutDialog";
import {ServerAPI} from "../1. Core/ServerAPI";
import {secondsToTime, timeToSec} from "../10. Battle/Util";

export class EndBoutDialog extends Dialog {
    private _Battle: IBattle;
    private _chooseWinnerListHeader: Label;
    private _chooseWinnerList: Select;
    private _winTypeSelect: Select;
    private _winDesc: TextField;
    private _endTime: TimeEdit;
    private _EndTimeStr: string;
    private _LastEvent: HighlightRow;

    _initFields(settings: object) {

        this._Battle = null;
        this._EndTimeStr = '';
        this._LastEvent = null;
        super._initFields(settings);
        this._Mode = 'FullHeight';
        this._Caption = this._Battle.Name;
        this._CloseOnFrameMouseDown = true;
        this._ShowHeader = true;
        this._ShowCloseButton = true;
        this._OkRK = 'Save'
    }

    _render() {
        super._render();

        this._chooseWinnerListHeader = new Label({
            ParentNode: this._contentNode,
            RK: 'Winner'
        });

        this._chooseWinnerList = new Select({
            ParentNode: this._contentNode,
            Items: [{
                Value: this._Battle.Red,
                Content: this._Battle.RedName,
                Font: new Font({
                    Color: NP.RED_COLOR
                })
            }, {
                Value: this._Battle.Blue,
                Content: this._Battle.BlueName,
                Font: new Font({
                    Color: NP.BLUE_COLOR
                })
            }, {
                Value: ' ',
                RK: 'Draw',
            }],
            EvItemSelected: () => this.checkOkEnabled()
        });

        this._winTypeSelect = new Select({
            ParentNode: this._contentNode,
            FloatingLabel: NP.RM.getString('WinType').replace("{0}:", ""),
            Value: this._Battle.WinType,
            Items: CreateBoutDialog.getWinTypeItems(),
            EvItemSelected: () => this.checkOkEnabled()
        });

        this._winDesc = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: NP.RM.getString('WinDescription'),
            Value: this._Battle.WinDescription
        });

        if (this._LastEvent && this._LastEvent.Action == 'Submission') {
            if (this._LastEvent.HLDesc)
                this._winDesc.setValue(this._LastEvent.HLDesc)
            else {
                this.updateLastEventDesc()
            }
        }
        this.refresh();
    }

    async updateLastEventDesc() {
        const ev = await ServerAPI.get<HighlightRow>(`/mma/getLastEvent/${this._Battle.Id}?round=${this._LastEvent.Round}`)

        if (!ev.HLDesc) {
            setTimeout(() => this.updateLastEventDesc(), 1000)
        } else {
            if (this._LastEvent)
                this._LastEvent.HLDesc = ev.HLDesc
            else
                this._LastEvent = ev;
            this._winDesc.setValue(this._LastEvent.HLDesc)
        }
    }

    async refresh() {


        this._Battle = await ServerAPI.get<IBattle>(`/battle/${this._Battle.Id}`)

        if (this._EndTimeStr) {
            let maxSec = 15 * 60;
            if (this._Battle.RoundCount && this._Battle.RoundLength)
                maxSec = this._Battle.RoundCount * this._Battle.RoundLength * 60;

            if (timeToSec(this._EndTimeStr) > maxSec) {
                this._EndTimeStr = secondsToTime(maxSec);
            }
        }


        this._endTime = new TimeEdit({
            ParentNode: this._contentNode,
            FloatingLabel: NP.RM.getString('WinTime'),
            FontImage: NP.FontImages.url,
            Value: this._EndTimeStr,
            Mode: TimeEditMode.MinutesSeconds
        });

        this.checkOkEnabled();

    }

    checkOkEnabled() {
        this._okButton.setEnabled(this._chooseWinnerList.getValue() && this._winTypeSelect.getValue());
    }

    async doSave() {

        await ServerAPI.post(`/battle/${this._Battle.Id}`, {
            ...this._Battle,
            Winner: this._chooseWinnerList.getValue(),
            WinType: this._winTypeSelect.getValue(),
            WinDescription: this._winDesc.getValue(),
            EndTime: '00:' + this._endTime.getValue(),
            Status: 'Finished'
        });

        this.EvOkButtonClick.fire(this)

        this.hide();
    }

    async _onOkButtonClick() {
        let winRound = this._Battle.WinRound || 1

        let totalBattleSeconds = timeToSec(this._endTime.getValue())

        let minSeconds = (winRound - 1) * this._Battle.RoundLength * 60;

        if (minSeconds > totalBattleSeconds)
            return NP.showMessage({
                Content: `End time cannot be less than ${secondsToTime(minSeconds)}`
            })

        if (minSeconds < totalBattleSeconds) {
            switch (this._winTypeSelect.getValue()) {
                //(UD MD или SD только с подтверждением)
                case 'UD':
                case 'MD':
                case 'SD':
                    return NP.showConfirm({
                        Content: 'Вы уверены что бой завершился Решением?',
                        EvOkButtonClick: async () => {
                            this.doSave()
                        }
                    }).show();
            }
        }

        if (minSeconds == totalBattleSeconds) {
            switch (this._winTypeSelect.getValue()) {
                case 'UD':
                case 'MD':
                case 'SD':
                    break
                default:
                    return NP.showConfirm({
                        Content: 'Вы уверены что бой завершился Досрочно?',
                        EvOkButtonClick: async () => {
                            this.doSave()
                        }
                    }).show();
            }
        }

        this.doSave()

    }
}